import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const LoadingSpinner = ({
  isInline = false,
  overlay,
  minHeight = 'initial',
  spinnerSize = 'xl',
  leftMargin = '50%',
  color = 'primaryScale.600'
}) => {
  let style = {
    position: 'initial',
    minHeight: '100vh'
  };

  if (overlay) {
    style = {
      ...style,
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backdropFilter: 'blur(8px)',
      zIndex: 10
    };
  } else if (isInline) {
    style = {
      ...style,
      minHeight,
      position: 'relative'
    };
  }

  return (
    <Box style={style}>
      <Box
        display="inline"
        left={leftMargin}
        position="absolute"
        top="50%"
        transform="translate(-50%, -50%)"
        zIndex="9"
      >
        <Spinner
          color={color}
          emptyColor="gray.200"
          size={spinnerSize}
          speed="0.65s"
          thickness="4px"
        />
      </Box>
    </Box>
  );
};

LoadingSpinner.propTypes = {
  isInline: PropTypes.bool,
  absolute: PropTypes.bool,
  overlay: PropTypes.bool,
  /** Minimum height for the container */
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Chakra-UI size options for spinner */
  spinnerSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

export default LoadingSpinner;
